import { IFlyingCart } from "@features/cart/IFlyingCart";
import { useStyle } from "../FlyingCartLayouts/style";
import { Divider, Collapse, IconButton, SvgIcon } from "@mui/material";
import { OrderSummaryTotal } from "./OrderSummaryTotal/OrderSummaryTotal";
import { FlyingCartItems } from "./FlyingCartItems";
import DownArrow from "@static/icons/DownArrow.svg";
import { useTranslation } from "react-i18next";

interface IParams {
    flyingCart: IFlyingCart;
    isExpanded: boolean;
    onToggleItemsExpanded?(): void;
}

export const OrderSummaryContent = (props: IParams) => {
    const { flyingCart, isExpanded = false, onToggleItemsExpanded } = props;
    const { classes } = useStyle({ isExpanded });
    const { t } = useTranslation("cart");

    return (
        <>
            <Collapse in={isExpanded}>
                <FlyingCartItems flyingCart={flyingCart} />
            </Collapse>
            {isExpanded && <Divider className={classes.flyingCartDivider} />}
            <OrderSummaryTotal
                monthlyTotal={flyingCart.totalRecurringAmount}
                oneOffTotal={flyingCart.totalUpFrontAmount}
            />
            {onToggleItemsExpanded && (
                <div className={classes.orderSummaryToggleButtonContainer}>
                    <IconButton
                        aria-label={isExpanded ? t("collapseItems") : t("expandItems")}
                        className={classes.orderSummaryToggleButton}
                        size="small"
                        onClick={onToggleItemsExpanded}
                    >
                        <SvgIcon
                            className={classes.orderSummaryToggleArrowWithRotation}
                            component={DownArrow}
                            inheritViewBox
                        />
                    </IconButton>
                </div>
            )}
        </>
    );
};
